export class HiveClass {
  constructor(
    id,
    overallFrames,
    beeFrames,
    broodFrames,
    spotty,
    queenCells,
    broodSpotty,

    foodFrames,
    honeyFrames,
    aggression,
    miteCount,
    diseases,

    diseaseResistance,
    queenStats,
    birth,
    alive,
    lastMutated,
    position,
    notes
  ) {
    console.log("instantiating");
    this.id = id;
    this.overallFrames = overallFrames;
    this.beeFrames = beeFrames;
    this.broodFrames = broodFrames;
    this.spotty = spotty;
    this.queenCells = queenCells;
    this.broodSpotty = broodSpotty;
    this.foodFrames = foodFrames;
    this.honeyFrames = honeyFrames;
    this.aggression = aggression;
    this.miteCount = miteCount;
    this.diseases = diseases;

    this.diseaseResistance = diseaseResistance;
    this.queenStats = queenStats;
    this.birth = birth;
    this.alive = alive;
    this.lastMutated = lastMutated;
    this.position = position;
    this.notes = notes;
  }
}
